// Public landing pages and the list modes they create.
export const LIST_TOOLS = [
  { id: "bring", path: "", available: true, icon: "bringlist.png" },
  { id: "simple", path: "simple-list", available: true, icon: "simplelist.png" },
  { id: "participants", path: "participant-list", available: true, icon: "participants.png" },
  { id: "tasks", path: "shared-task-list", available: true, icon: "todo.png" },
];

export function getListTool(id) {
  return LIST_TOOLS.find(tool => tool.id === id) || LIST_TOOLS[0];
}
